/**
 * see: gui_common.docx, chapter Common page data
 */
export interface CommonPageData {
  /**
   * Wireframe ID, e.g. '2.1.1'
   */
  pageId?: string;

  /**
   * Langtext key for page title.
   * Title can be defined specific just for one page OR can be used common title depending on module.
   * see: GUI doc. subchapter 'Page title'
   */
  pageTitle: string;

  /**
   * URL link to HTML template.
   * see: GUI doc. subchapter 'Template url'
   */
  templateUrl?: string;

  /**
   * Specifies whether the page is accessible to anonymous user (identified by anonymous JWT).
   * see: GUI doc. subchapter 'Visibility for anonym'
   */
  visibleForAnonym?: boolean;

  /**
   * Specifies whether the page has a simple structure and not contains header and footer
   * see: Guid doc. subchapter 'Simple page'
   */
  simplePage?: boolean;
}

/**
 * Builds the URL for SOC theme HTML template.
 */
export const socThemeScreensUrl = (templatePath: string): string =>
  `http://soctheme.cz.o2/screens/onecrm/${templatePath}`;
